export default __webpack_public_path__ + "static/media/multimedia.3f2a26bb.svg";